module.exports = __webpack_public_path__ + "static/media/FlaSEIA-Logo.d689c099.jpeg";